import React, { useState } from 'react';

function Series({ series, teams, socket, user }) {
  const [newSeries, setNewSeries] = useState('');

  const addSeries = (e) => {
    e.preventDefault();
    if (newSeries.trim() === '' || !socket) return;
    socket.emit('addSeries', { name: newSeries });
    setNewSeries('');
  };

  const handleTeamSeriesChange = (seriesId, teamId, isChecked) => {
    if (!socket) return;
    if (isChecked) {
      socket.emit('addTeamToSeries', { series_id: seriesId, team_id: teamId });
    } else {
      socket.emit('removeTeamFromSeries', { series_id: seriesId, team_id: teamId });
    }
  };

  const canEdit = user && (user.role === 'SuperAdmin' || user.role === 'Admin');

  return (
    <div className="series-section">
      <h2>Sarjat</h2>
      {canEdit && (
        <form onSubmit={addSeries}>
          <input
            type="text"
            value={newSeries}
            onChange={(e) => setNewSeries(e.target.value)}
            placeholder="Anna uuden sarjan nimi"
          />
          <button type="submit">Lisää sarja</button>
        </form>
      )}
      <ul>
        {series.map((s) => (
          <li key={s.id}>
            <strong>{s.name}</strong>
            <div>
              {teams.map(team => (
                <div key={team.id}>
                  <input
                    type="checkbox"
                    checked={s.teams && s.teams.split(',').includes(team.name)}
                    onChange={(e) => handleTeamSeriesChange(s.id, team.id, e.target.checked)}
                    disabled={!canEdit}
                  />
                  {team.name}
                </div>
              ))}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Series;
